import { useRouter } from 'next/router';
import ArrowIcon from 'public/icon/Arrow';
import ArrowBar from 'public/icon/ArrowBar';
import { getUtmsFromQuery } from '@utils/utmUtil';
import { LAWTALK_SIGNUP_URL } from '@shared/values';
import { sendAmplitudeEvent } from '../../../utils/amplitude';

const Guide = ({ isMobile }: { isMobile?: boolean }) => {
  const router = useRouter();

  const goLawtalkSignup = () => {
    const pathname = router.pathname || '';
    const utms = getUtmsFromQuery(router.query);
    const signupUrl = LAWTALK_SIGNUP_URL({
      pagePath: pathname,
      utms: { ...utms, utm_content: '개업미리보기' },
    });
    sendAmplitudeEvent('sqr_click_preview', { label: 'sign-up' });
    window.open(signupUrl);
  };

  return (
    <div className="for-lawyer__guide">
      <section className="for-lawyer__guide-1">
        <p className="for-lawyer__guide-sub-title view-on-visible">로톡 가이드 01.</p>
        <p className="for-lawyer__guide-title view-on-visible">
          한 눈으로 알아보는&nbsp;
          {isMobile && <br />}
          로톡 이용 방법
        </p>
        <div className="for-lawyer__ad">
          <div className="for-lawyer__ad-title view-on-visible">광고 미이용 시</div>
          <div className="for-lawyer__ad-step-container view-on-visible">
            <div className="for-lawyer__ad-step">변호사 회원 가입</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">변호사 인증 및 프로필 작성</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">로톡 솔루션 신청</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">상담 시간 및 가격 설정</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">의뢰인 상담 진행</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">상담료 정산</div>
          </div>
        </div>
        <div className="for-lawyer__ad for-lawyer__ad-use">
          <div className="for-lawyer__ad-title view-on-visible">광고 이용 시</div>
          <div className="for-lawyer__ad-step-container view-on-visible">
            <div className="for-lawyer__ad-step">변호사 회원 가입</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">변호사 인증 및 프로필 작성</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">로톡 솔루션&amp;광고신청</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">상담 시간 및 가격 설정</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step highlight-step">광고 전략 미팅</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">의뢰인 상담 진행</div>
            <div className="for-lawyer__ad-step-arrow">
              <ArrowIcon />
            </div>
            <div className="for-lawyer__ad-step">상담료 정산</div>
          </div>
        </div>
      </section>
      <section className="for-lawyer__guide-2">
        <p className="for-lawyer__guide-sub-title view-on-visible">로톡 가이드 02.</p>
        <p className="for-lawyer__guide-title view-on-visible">
          개업 변호사&nbsp;
          {isMobile && <br />}
          로톡 이용 전 / 후 비교
        </p>
        <div className="for-lawyer-use-container">
          <div className="for-lawyer-use for-lawyer-before-use view-on-visible">
            <div className="for-lawyer-before-use-title">로톡 이용 전</div>
            <ul className="for-lawyer-before-use-list">
              <li className="for-lawyer-before-use-list-item">주변 지인과 변호사 마케팅에 대해 고민한다.</li>
              <li className="for-lawyer-before-use-list-item">영업을 위해 업무 시간 일부를 할애한다.</li>
              <li className="for-lawyer-before-use-list-item">지인 중심의 마케팅을 한다.</li>
            </ul>
          </div>
          <div className="for-lawyer-use for-lawyer-after-use view-on-visible">
            <div className="for-lawyer-after-use-title">로톡 이용 후</div>
            <ul className="for-lawyer-after-use-list">
              <li className="for-lawyer-after-use-list-item">
                비즈니스 매니저라는 <span className="for-lawyer-after-use-list-item-bold">든든한 조력자</span>가 생긴다.
              </li>
              <li className="for-lawyer-after-use-list-item">
                <span className="for-lawyer-after-use-list-item-bold">전문가와 함께&nbsp;</span>변호사 마케팅을 고민할
                수 있다.
              </li>
              <li className="for-lawyer-after-use-list-item">
                변호사 <span className="for-lawyer-after-use-list-item-bold">본연의 업무에 집중</span>할 수 있다.
              </li>
              <li className="for-lawyer-after-use-list-item">
                전화상담, 영상상담 등 <span className="for-lawyer-after-use-list-item-bold">추가 수입이 발생</span>
                한다.
              </li>
              <li className="for-lawyer-after-use-list-item">
                <span className="for-lawyer-after-use-list-item-bold">전국 단위의 마케팅</span>이 가능해진다.
              </li>
              <li className="for-lawyer-after-use-list-item">빠르게 개업 변호사로 자리 잡게 된다.</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="for-lawyer__guide-3">
        <p className="for-lawyer__guide-sub-title view-on-visible">로톡 가이드 03.</p>
        <p className="for-lawyer__guide-title view-on-visible">
          전담 비즈니스 매니저가&nbsp;
          {isMobile && <br />}
          생기면&nbsp;
          {!isMobile && <br />}
          어떤 게 달라질까요?
        </p>
        <ul className="for-lawyer-after-use-list">
          <li className="for-lawyer-after-use-list-item view-on-visible">
            어느 곳에서도 들을 수 없었던&nbsp;
            <span className="for-lawyer-after-use-list-item-bold">실제 개업 노하우</span>를 얻을 수 있습니다.
          </li>
          <li className="for-lawyer-after-use-list-item view-on-visible">
            로톡을 통해 안정적으로 영업 기반을 잡고 로펌을 확장해 나가는 성공 사례를 통해&nbsp;
            <span className="for-lawyer-after-use-list-item-bold">변호사님 상황에 맞는 마케팅 방향을 제안</span>받을 수
            있습니다.(전문 분야, 지역 등)
          </li>
          <li className="for-lawyer-after-use-list-item view-on-visible">
            성과와 이슈 대응에 특화된 밀착관리를 통해 자연스럽게&nbsp;
            <span className="for-lawyer-after-use-list-item-bold">변호사 업무에 집중</span>할 수 있게 됩니다.
          </li>
        </ul>
        {/* 예약 임베드 url */}
        <div className="reservation-container view-on-visible">
          <div
            className="whattime-inline-widget"
            data-code="y8JdqeNqmV"
            data-text-color="#FF5500"
            data-button-color="#FF5500"
            data-background-color="#FFFFFF"
            style={{ minWidth: '320px', height: '880px' }}
          >
            {' '}
          </div>
          <link href="https://whattime.co.kr/widget/widget.css" rel="stylesheet" />
          <script src="https://whattime.co.kr/widget/widget.js" type="text/javascript" async></script>
        </div>
      </section>
      <section className="for-lawyer__guide-4">
        <p className="for-lawyer__guide-sub-title view-on-visible">로톡 가이드 04.</p>
        <p className="for-lawyer__guide-title view-on-visible">
          변호사 개업 A to Z,
          <br />
          로톡이 적극적으로 도와드립니다
        </p>
        <div className="for-lawyer-guide-links">
          <a
            href="https://www.lawtalk.co.kr/with-lawyer"
            className="for-lawyer-guide-link view-on-visible"
            target="_blank"
            onClick={() => sendAmplitudeEvent('sqr_click_preview', { label: 'with-lawyer' })}
          >
            지금 가입해도 괜찮을까? 합법 히스토리 살펴보기
            <div className="arrow-icon">
              <ArrowBar width={25} height={25} />
            </div>
          </a>
          <a
            href="https://lawyer.lawtalk.co.kr/fursys"
            className="for-lawyer-guide-link view-on-visible"
            target="_blank"
            onClick={() => sendAmplitudeEvent('sqr_click_preview', { label: 'interior' })}
          >
            개업 준비, 사무실 인테리어 고민 중이라면?
            <div className="arrow-icon">
              <ArrowBar width={25} height={25} />
            </div>
          </a>
          <button className="for-lawyer-guide-link view-on-visible" onClick={goLawtalkSignup}>
            로톡 변호사 회원 가입하기
            <div className="arrow-icon">
              <ArrowBar width={25} height={25} />
            </div>
          </button>
        </div>
      </section>
    </div>
  );
};

export default Guide;
